import React, { useEffect, useState } from 'react'

import { GiphyFetch } from "@giphy/js-fetch-api";
import { Gif, Grid, Carousel } from "@giphy/react-components";
import ResizeObserver from "react-resize-observer";
import Button from '../utils/components/Button/Button';
import { useDispatch, useSelector } from 'react-redux';
import { seeStikers } from '../actions/userActions';

const giphyFetch = new GiphyFetch("jsMPlKIr11iKyoftce2K5Spnj7ezSeMp");

const ModalGif = ({ displayModal, closeModal, withStiker, setData, setOnlygif }) => {
    const {ecoStikers} = useSelector(state =>state.userInfo)
    const dispatch = useDispatch()

    useEffect(() => {
      dispatch(seeStikers())
    
      return () => {
        
      }
    }, [])
    

    const divStyle = {
        display: displayModal ? 'block' : 'none'
    }
    const close = (e) => {
        e.stopPropagation()
        closeModal(e)
    }

    const [typeData, setTypeData] = useState(0)

    const uploadGif = async (data,e,close) => {
        e.persist()
        console.log()
        


        var visual_ext = data.original.url.split('.').pop();
        var visual = await fetch(data.original.url);
        console.log();
        var visual_as_blob = await visual.blob();
        console.log();
        var visual_as_file = new File([visual_as_blob], 'gif_or_sticker.' + visual_ext, { lastModified: new Date().getTime(), type: visual_as_blob.type });
        console.log();
        // form_file.append('file', visual_as_file);
        //setData( {[sticker.url.hash]:{url:sticker.url.origin,file:visual_as_file}})

        setData({ [data.fixed_height_downsampled.url]: { url: data.fixed_height_downsampled.url, type:visual_as_blob.type, file: visual_as_file } })
        close(e)
        setOnlygif(true)

    }

    const [search, setSearch] = useState('')
    const [modalGif, setModalGif] = useState();

    const GridEcoStickers = () => {
        return (
            <div className='grid-eco-stickers'>
                {
                    ecoStikers.map(sticker => (
                        <div className='grid-eco-stickers-sticker' onClick={async (e) => {
                            e.persist()




                            var visual_source = sticker.image.url.origin;
                            var visual_ext = visual_source.split('.').pop();
                            var visual = await fetch(visual_source);
                            console.log();
                            var visual_as_blob = await visual.blob();
                            console.log();
                            var visual_as_file = new File([visual_as_blob], 'eco_sticker.' + visual_ext, { lastModified: new Date().getTime(), type: visual_as_blob.type });
                            console.log();
                            // form_file.append('file', visual_as_file);
                            //setData({ [sticker.name]: { url: sticker.url.origin, file: visual_as_file } })
                            setData({ [sticker.image.url.origin]: { url: sticker.image.url.origin, type:visual_as_blob.type, file: visual_as_file } })
                            close(e)


                            /*
                                                        var request = new XMLHttpRequest();
                                                        request.responseType = "blob";
                                                        request.onload = function () {
                                                            console.log();
                                                            console.log();
                                                            request.response.name ='azu.png'
                                                            setData( {[sticker.url.hash]:{url:'https://d3ggxoihlln4pt.cloudfront.net/61eeb625cffafc1ff4357402/resized-1024-2826573stickerCa.png',file:request.response } })
                                                            return;
                                                        };*/
                            // request.open("GET", sticker.url.origin);
                            //  request.send();
                            // setData( {[sticker.url.hash]:{url:sticker.url.origin,file:{url:sticker.url.origin,  type: 'image/gif'  }}})
                            // close(e)
                        }}>
                            <img src={sticker.image.url.origin} />

                        </div>
                    ))
                }
            </div>
        )
    }
    function GridDemo({ onGifClick }) {
        const fetchGifs = (offset) => {
            if (typeData ===0)
                if (search != '')
                    return giphyFetch.search(search, { offset, limit: 10 })
                else
                    return giphyFetch.trending({ offset, limit: 10 })
            else if (typeData ===1)
                if (search != '')
                    return giphyFetch.search(search, { offset, limit: 10, type: 'stickers' })
                else
                    return giphyFetch.trending({ offset, limit: 10, type: "stickers" })
        }
        const [width, setWidth] = useState(window.innerWidth);
        return (
            <>
                <Grid
                    onGifClick={onGifClick}
                    fetchGifs={fetchGifs}
                    width={width}
                    noLink
                    columns={3}
                    gutter={6}
                />
                <ResizeObserver
                    onResize={({ width }) => {
                        setWidth(width);
                    }}
                />
            </>
        );
    }

    if (displayModal)
        return (
            <div
                className={"modal modal-gif-new-post"}
                onClick={close}
                style={divStyle} >
                <div
                    className="modal-content modal-content-gif"
                    onClick={e => e.stopPropagation()}
                >
                    {true && <div className="content-options-gif-stiker">
                        <Button onClick={() => setTypeData(0)} active={typeData ===0} text ='Gif'/>
                        <Button onClick={() => setTypeData(1)} active={typeData ===1}  text ='Sticker'/>
                        <Button onClick={() => setTypeData(2)} active={typeData ===2}  text ='Eco-Sticker'/>
                    </div>}
                    <div>
                        <input
                            className='input-room-create input-modal-stiker'
                            name="search"
                            value={search}
                            type="text"
                            placeholder='Buscar'
                            onChange={e => setSearch(e.target.value)}
                            onMouseOut={e => setSearch(e.target.value)}
                        />

                        <div className="content-stiker-modal scroll-menu">
                            {
                                typeData != 2 && (
                                    <GridDemo
                                        onGifClick={(gif, e) => {
                                            e.preventDefault();
                                            uploadGif(gif.images,e,close)
                                            
                                        }}
                                    />
                                )
                            }
                            {
                                typeData ===2 && (
                                    <GridEcoStickers />

                                )
                            }

                        </div>
                    </div>
                </div>
            </div>
        )
    else
        return <div></div>
}
export default ModalGif;